import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class AlertService {
  private successToasterConfig = {
    timeOut: 3000,
    extendedTimeOut: 1000
  };

  private toasterConfig = {
    disableTimeOut: true,
    tapToDismiss: true
  };

  constructor(private toaster: ToastrService) {
  }

  public success(message: string, title?: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const toast = this.toaster.success(message, title, this.successToasterConfig);
      toast.onHidden.subscribe(result => resolve(result),
        error => reject(error));
    });
  }

  public info(message: string, title?: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const toast = this.toaster.info(message, title, this.successToasterConfig);
      toast.onHidden.subscribe(result => resolve(result),
        error => reject(error));
    });
  }

  public error(message: string, title?: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const toast = this.toaster.error(message, title, this.toasterConfig);
      toast.onHidden.subscribe(result => resolve(result),
        error => reject(error));
    });
  }

  public warning(message: string, title?: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const toast = this.toaster.warning(message, title, this.toasterConfig);
      toast.onHidden.subscribe(result => resolve(result),
        error => reject(error));
    });
  }

  public custom(message: string, title?: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const toast = this.toaster.show(message, title, this.toasterConfig);
      toast.onHidden.subscribe(result => resolve(result),
        error => reject(error));
    });
  }
}
